"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var URI = require("urijs");
exports.parseQueryParams = function (query) {
    if (query === void 0) { query = ''; }
    var uri = new URI(query);
    return URI.parseQuery(uri.query());
};
exports.encodeQueryParams = function (params) {
    var encodedParams = Object.entries(params).map(function (param) { return param[0] + "=" + encodeURIComponent(param[1]); });
    return "?" + encodedParams.join('&');
};
exports.addQueryParams = function (url, queryParams) {
    if (url === void 0) { url = ''; }
    return new URI(url).addQuery(queryParams).toString();
};
